var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45770_79996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8325 18.3307H5.45455C5.08199 18.3307 4.71453 18.244 4.3813 18.0774V18.0774C3.91686 17.8451 3.54027 17.4686 3.30805 17.0041V17.0041C3.14143 16.6709 3.05469 16.3034 3.05469 15.9309V7.33073V5.26397C3.05469 5.01559 3.11252 4.77063 3.22359 4.54847L3.40132 4.19302C3.56341 3.86884 3.89475 3.66406 4.2572 3.66406V3.66406C4.26928 3.66406 4.28032 3.67089 4.28573 3.68169L4.69023 4.49071C4.82141 4.75306 4.9896 4.99522 5.18963 5.20975L5.29909 5.32714C5.58985 5.63898 5.95676 5.86977 6.36374 5.99685V5.99685C6.60078 6.07086 6.84767 6.10851 7.09599 6.10851H7.94358H9.77691H11.6102H13.7504C13.9525 6.10851 14.1538 6.08372 14.3499 6.03471V6.03471C14.9464 5.88558 15.4659 5.51947 15.807 5.00788L15.888 4.88628L16.4903 3.68169C16.4957 3.67089 16.5068 3.66406 16.5188 3.66406V3.66406C16.8813 3.66406 17.2126 3.86884 17.3747 4.19302L17.5524 4.54847C17.6635 4.77063 17.7214 5.01559 17.7214 5.26397V6.10851V7.33073V14.053",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 9.16406H11.612",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 12.8359H12.8342",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.4965,
    cy: 17.7231,
    r: 3.66667,
    stroke: "white",
    strokeWidth: 1.22222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 17.7222L15.7999 18.858C15.8476 18.9058 15.925 18.9058 15.9727 18.858L18.3307 16.5",
    stroke: "white",
    strokeWidth: 1.22222,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 2.44531H12.8342",
    stroke: "white",
    strokeWidth: 3.66667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.89062,
    y: 8.55469,
    width: 1.22222,
    height: 1.22222,
    rx: 0.611111,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.89062,
    y: 12.2188,
    width: 1.22222,
    height: 1.22222,
    rx: 0.611111,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45770_79996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcon);
export default __webpack_public_path__ + "static/media/todo-icon.da97bb60baa7be7e46dd281c727c196b.svg";
export { ForwardRef as ReactComponent };